import { SECOND_IN_MILLISECONDS } from '../constants'

export const convertBlockTimestampToDate = (timestamp: number | bigint) =>
  new Date(Number(timestamp) * SECOND_IN_MILLISECONDS)
